import './App.css';
import './styles/ftm-landing.css';
import './index.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import HomePageRedesigned from './pages/HomePageRedesigned';
import BlogListPage from './pages/BlogListPage';
import BlogPostPage from './pages/BlogPostPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import RefundPolicy from './pages/RefundPolicy';
import { getBlogPost } from './data/blogPosts';

const DEFAULT_TITLE = 'Support 4 Help | Family Tree Maker Support';

const PAGE_TITLES = {
  '/': DEFAULT_TITLE,
  '/privacy-policy': 'Privacy Policy | Support 4 Help',
  '/terms-and-conditions': 'Terms and Conditions | Support 4 Help',
  '/refund-policy': 'Refund Policy | Support 4 Help',
  '/blog': 'Guides & Articles | Support 4 Help',
};

function DocumentTitle() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/blog/')) {
      const slug = location.pathname.replace('/blog/', '');
      const post = getBlogPost(slug);
      document.title = post ? `${post.title} | Support 4 Help` : 'Article | Support 4 Help';
      return;
    }
    document.title = PAGE_TITLES[location.pathname] || DEFAULT_TITLE;
  }, [location.pathname]);

  return null;
}

function AppRoutes() {
  return (
    <>
      <DocumentTitle />
      <Routes>
        <Route path="/" element={<HomePageRedesigned />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
